/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {

  const footerStyle = {
    background:
      "linear-gradient(to bottom,#050505,#0b0b0b)",

    color: "#ddd",

    padding: "75px 0 28px",

    position: "relative",

    overflow: "hidden",

    borderTop:
      "1px solid rgba(216,176,110,0.12)",
  };

  const headingStyle = {
    fontFamily:
      "'Cormorant Garamond', serif",

    fontSize: "38px",

    letterSpacing: "1px",

    background:
      "linear-gradient(to right,#fff,#d8b06e)",

    WebkitBackgroundClip: "text",

    WebkitTextFillColor: "transparent",

    marginBottom: "14px",
  };

  const subHeadingStyle = {
    color: "#fff",

    fontSize: "17px",

    letterSpacing: "2px",

    marginBottom: "18px",
  };

  const textStyle = {
    color:
      "rgba(255,255,255,0.68)",

    lineHeight: "1.9",

    fontSize: "14px",
  };

  const iconWrapStyle = {
    width: "52px",

    height: "52px",

    borderRadius: "50%",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    background:
      "linear-gradient(to bottom,rgba(255,255,255,0.06),rgba(255,255,255,0.02))",

    border:
      "1px solid rgba(216,176,110,0.14)",

    transition: ".4s ease",

    cursor: "pointer",

    backdropFilter: "blur(12px)",
  };

  const iconStyle = {
    color: "#d8b06e",
    fontSize: "18px",
  };

  return (
    <footer style={footerStyle}>

      {/* TOP GLOW */}
      <div
        style={{
          position: "absolute",

          width: "380px",
          height: "380px",

          background:
            "radial-gradient(circle,rgba(216,176,110,0.12),transparent 70%)",

          filter: "blur(90px)",

          top: "-120px",
          right: "-120px",
        }}
      />

      {/* BOTTOM GLOW */}
      <div
        style={{
          position: "absolute",

          width: "300px",
          height: "300px",

          background:
            "radial-gradient(circle,rgba(216,176,110,0.08),transparent 70%)",

          filter: "blur(90px)",

          bottom: "-120px",
          left: "40%",
        }}
      />

      <div className="container position-relative">

        <div className="row gy-4 align-items-start">

          {/* LEFT */}
          <div className="col-lg-4">

            <h3 style={headingStyle}>
              Arson's Beauty Zone
            </h3>

            <p style={textStyle}>
              Arson's Beauty Zone is a premium beauty
              parlour and bridal makeup studio in
              Prayagraj Jhusi offering luxury bridal
              makeup, hairstyling, skincare and
              beauty salon services.
            </p>

            {/* SOCIALS */}
            <div
              className="d-flex gap-3 mt-4"
            >

              {/* FACEBOOK */}
              <div
                style={iconWrapStyle}
                onMouseOver={(e)=>{
                  e.currentTarget.style.transform =
                    "translateY(-5px)";

                  e.currentTarget.style.background =
                    "rgba(216,176,110,0.12)";
                }}
                onMouseOut={(e)=>{
                  e.currentTarget.style.transform =
                    "translateY(0)";

                  e.currentTarget.style.background =
                    "linear-gradient(to bottom,rgba(255,255,255,0.06),rgba(255,255,255,0.02))";
                }}
              >
                <FaFacebookF style={iconStyle} />
              </div>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/arsonsbeautyzone/"
                target="_blank"
                rel="noreferrer"
                style={{
                  textDecoration: "none",
                }}
              >
                <div
                  style={iconWrapStyle}
                  onMouseOver={(e)=>{
                    e.currentTarget.style.transform =
                      "translateY(-5px)";

                    e.currentTarget.style.background =
                      "rgba(216,176,110,0.12)";
                  }}
                  onMouseOut={(e)=>{
                    e.currentTarget.style.transform =
                      "translateY(0)";

                    e.currentTarget.style.background =
                      "linear-gradient(to bottom,rgba(255,255,255,0.06),rgba(255,255,255,0.02))";
                  }}
                >
                  <FaInstagram style={iconStyle} />
                </div>
              </a>

              {/* TWITTER */}
              <div
                style={iconWrapStyle}
                onMouseOver={(e)=>{
                  e.currentTarget.style.transform =
                    "translateY(-5px)";

                  e.currentTarget.style.background =
                    "rgba(216,176,110,0.12)";
                }}
                onMouseOut={(e)=>{
                  e.currentTarget.style.transform =
                    "translateY(0)";

                  e.currentTarget.style.background =
                    "linear-gradient(to bottom,rgba(255,255,255,0.06),rgba(255,255,255,0.02))";
                }}
              >
                <FaTwitter style={iconStyle} />
              </div>

            </div>

          </div>

          {/* CENTER */}
          <div className="col-lg-4">

            <h5 style={subHeadingStyle}>
              CONTACT INFO
            </h5>

            <div className="d-flex gap-3 mb-3">

              <FaPhoneAlt
                style={{
                  color: "#d8b06e",
                  marginTop: "5px",
                }}
              />

              <div>
                <p style={textStyle}>
                  +91 6394941232
                </p>

                <p style={textStyle}>
                  +91 7800400041
                </p>
              </div>

            </div>

            <div className="d-flex gap-3 mb-3">

              <FaEnvelope
                style={{
                  color: "#d8b06e",
                  marginTop: "5px",
                }}
              />

              <p style={textStyle}>
                arsonsbeautyzone@gmail.com
              </p>

            </div>

            <div className="d-flex gap-3">

              <FaMapMarkerAlt
                style={{
                  color: "#d8b06e",
                  marginTop: "5px",
                }}
              />

              <p style={textStyle}>
               1/220 MIG AVAS VIKAS COLONY JHUSI PRAYAGRAJ
              </p>

            </div>

             <div className="d-flex gap-3">

              <FaMapMarkerAlt
                style={{
                  color: "#d8b06e",
                  marginTop: "5px",
                }}
              />

              <p style={textStyle}>
                Chhatnag road(near patanjali chikatsalaya), Jhusi, Prayagraj,
                Uttar Pradesh
              </p>

            </div>

          </div>

          {/* RIGHT */}
          <div className="col-lg-4">

            <h5 style={subHeadingStyle}>
              OPENING HOURS
            </h5>

            <div
              style={{
                background:
                  "rgba(255,255,255,0.03)",

                border:
                  "1px solid rgba(216,176,110,0.12)",

                borderRadius: "24px",

                padding: "24px",

                backdropFilter: "blur(14px)",

                boxShadow:
                  "0 20px 60px rgba(0,0,0,0.38)",

                transition: ".45s ease",
              }}

              onMouseOver={(e)=>{
                e.currentTarget.style.transform =
                  "translateY(-8px)";

                e.currentTarget.style.border =
                  "1px solid rgba(216,176,110,0.28)";
              }}

              onMouseOut={(e)=>{
                e.currentTarget.style.transform =
                  "translateY(0)";

                e.currentTarget.style.border =
                  "1px solid rgba(216,176,110,0.12)";
              }}
            >

              <div
                className="d-flex justify-content-between mb-2"
              >
                <p style={textStyle}>
                  Monday - Sunday
                </p>

                <p style={textStyle}>
                  11:00 AM-8:00 PM
                </p>
              </div>

             


              {/* BUTTON */}
              <a
                href="https://wa.me/916394941232"
                target="_blank"
                rel="noreferrer"

                style={{
                  background:
                    "linear-gradient(to right,#d8b06e,#f7d79b)",

                  color:"#111",

                  textDecoration:"none",

                  padding:"14px 22px",

                  borderRadius:"60px",

                  fontWeight:"700",

                  display:"inline-block",

                  marginTop:"22px",

                  width:"100%",

                  textAlign:"center",

                  boxShadow:
                    "0 15px 40px rgba(216,176,110,0.18)",
                }}
              >
                Book Appointment
              </a>

            </div>

          </div>

        </div>

        {/* BOTTOM LINE */}
        <div
          style={{
            width: "100%",
            height: "1px",

            background:
              "rgba(216,176,110,0.12)",

            marginTop: "45px",
            marginBottom: "18px",
          }}
        />

        {/* GOLD LINE */}
        <div
          style={{
            width:"80px",
            height:"2px",

            background:
              "linear-gradient(to right,#d8b06e,#f7d79b)",

            margin:"0 auto 22px",

            borderRadius:"20px",
          }}
        />

        {/* COPYRIGHT */}
        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-center"
        >

          <p
            style={{
              color:
                "rgba(255,255,255,0.42)",

              marginBottom:"0",

              letterSpacing:".5px",

              fontSize:"13px",
            }}
          >
            © 2026 Arson's Beauty Zone.
            All rights reserved.
          </p>

          <p
            style={{
              color:
                "rgba(255,255,255,0.42)",

              marginBottom:"0",

              letterSpacing:".5px",

              fontSize:"13px",
            }}
          >
            Designed & Developed by{" "}

            <a href="https://portfoliowebsite0101.netlify.app/"
            target="_blank"
            rel="noreferrer"
            >
              Ashutosh Kumar ✨
            </a>
          </p>

        </div>

      </div>
    </footer>
  );
};

export default Footer;